import React, { useState } from 'react'
import styles from "./serviceSection.module.css"
import Modal from '../../../modal'
import Popup from './popup';
import { notify } from '../../../toast'

const ServiceSection = (props) => {
    const [showPopUp, setShowPopUp] = useState(false);

    const [selectedService, setSelectedService] = useState("Pasirinkta paslauga");
    const [duration,setDuration] = useState();
    const [price, setPrice] = useState();

    const servicePopUpHandler = () => {
        setShowPopUp(true)
    }


    const onSubmitHandler = (obj) => {
        if(!obj.service_name || !obj.service_duration || (!obj===0 && !obj.service_price)){
            notify("Klaida, bandykite dar kartą","warning")
            return
        }
        setSelectedService(obj.service_name)
        setDuration(obj.service_duration)
        setPrice(obj.service_price)

        setShowPopUp(false)
        return props.onSelect(obj)
    }

    return (
        <div className={styles.container}>
            <Modal
                show={showPopUp}
                onClose={()=>{setShowPopUp(false)}}
            >
                <Popup onSubmit={onSubmitHandler} onClose={()=>{setShowPopUp(false)}} />
            </Modal>
            <h2 className={styles.select_service_btn} onClick={servicePopUpHandler}>
                {!duration && <span>--</span>}
                {selectedService}
                {!duration && <span>--</span>}
            </h2>
            
            <div className={styles.service_line_wrapper}>
                <h3>Trukmė: <span>{duration} {duration ? "Min" : "--"}</span></h3>
                <h3>Kaina: <span><>{price===0 ? "nemokama" : price}</> {(price || price === 0) ? <>{price===0 ? "" : "Eur"}</> : "--"}</span></h3>
            </div>

            <div className={styles.time_line_wrapper}>
                <div className={styles.line}>
                    <div style={{ backgroundColor:"#F57575" }} className={styles.dot}></div>
                    <h3>Užimtas laikas</h3>
                </div>

                <div className={styles.line}>
                    <div style={{ backgroundColor:"#CACFDD" }} className={styles.dot}></div>
                    <h3>Laisvas laikas</h3>
                </div>
            </div>

        </div>
    )
}

export default ServiceSection